<script setup lang="ts">
import { useI18n } from 'vue-i18n';

defineEmits<{
  (e: 'click'): void;
}>();

const { t } = useI18n();
</script>

<template>
  <button
    type="button"
    :aria-label="t('search.trigger')"
    class="group flex min-h-[44px] w-full max-w-[280px] items-center gap-2 rounded-lg border border-noir-700 bg-noir-900/80 px-3 text-left text-sm text-noir-300 transition-colors hover:border-noir-600 hover:bg-noir-800/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold-400/60 focus-visible:ring-offset-2 focus-visible:ring-offset-noir-950"
    @click="$emit('click')"
  >
    <svg class="h-4 w-4 shrink-0 text-noir-200 transition-colors group-hover:text-cream-100" viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
      <path d="M21 21L16.65 16.65" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <circle cx="11" cy="11" r="7" stroke-width="2" />
    </svg>
    <span class="truncate">{{ t('search.trigger') }}</span>
  </button>
</template>
